<template>
  <div>
    <v-layout
      class="mt-5"
      v-if="isLoading"
      align-center="align-center"
      justify-center="justify-center"
      column="column"
      fill-height="fill-height"
    >
      <v-progress-circular
        size="70"
        width="7"
        color="purple"
        indeterminate="indeterminate"
      ></v-progress-circular>
      <div>Loading...</div>
    </v-layout>
    <div v-if="!isLoading">
      <v-layout
        class="desktop-view-container"
        column="column"
        fill-height="fill-height"
      >
        <v-card class="border-r-0">
          <v-toolbar class="elevation-0" height="45" color="gray">
            <v-toolbar-title>
              <h1 class="subheading">{{ $t("pageHeader.editUser") }}</h1>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <h1
              class="subheading mr-1"
              v-if="currentUser.accountTypeID <= 2"
            >
              {{ $t("labels.active") }}
            </h1>
            <toggle-button
              :labels="true"
              v-model="User.isActive"
              :sync="true"
              v-if="currentUser.accountTypeID <= 2"
            ></toggle-button>
          </v-toolbar>
          <v-card-text>
            <v-layout
              justify-start="justify-start"
              row="row"
              fill-height="fill-height"
            >
              <v-flex xs2="xs2">
                <v-layout column="column"
                  ><img
                    class="br-50"
                    width="140"
                    height="160"
                    v-if="imageUrl"
                    :src="imageUrl"
                    alt="User"
                  /><img
                    class="br-50"
                    width="140"
                    height="160"
                    v-else="v-else"
                    src="../../../assets/images/user.jpeg"
                    alt="User"
                  />
                  <v-layout class="pa-0" row="row">
                    <v-btn fab="fab" color="red">
                      <v-icon color="white">delete</v-icon>
                    </v-btn>
                    <v-btn fab="fab" color="info" @click="pickFile">
                      <v-icon color="white">attach_file </v-icon>
                    </v-btn>
                  </v-layout> </v-layout
                ><input
                  type="file"
                  ref="image"
                  style="display: none"
                  accept="image/*"
                  @change="onFilePicked"
                />
              </v-flex>
              <v-flex class="ml-2" hidden-xs-only="hidden-xs-only">
                <h1 class="display-1 font-weight-regular">
                  {{ User.fullName }}
                </h1>
                <h2 class="title font-weight-light">{{ User.loginEmail }}</h2>
                <h2 class="caption mt-1">{{ accountName }}</h2>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
        <v-container fluid="fluid" grid-list-md="grid-list-md">
          <v-layout row="row" wrap="wrap">
            <v-flex xs12="xs12" sm6="sm6">
              <v-card>
                <v-toolbar class="elevation-0" height="45" color="gray">
                  <v-toolbar-title>
                    <h1 class="subheading">
                      {{ $t("pageHeader.userInformation") }}
                    </h1>
                  </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                  <form>
                    <v-layout row="row" wrap="wrap">
                      <v-flex xs12="xs12">
                        <v-text-field
                          :error-messages="fullNameErrors"
                          v-model="User.fullName"
                          label="Full name"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12="xs12" sm6="sm6">
                        <v-text-field
                          :error-messages="loginEmailErrors"
                          label="Login Email"
                          v-model="User.loginEmail"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12="xs12" sm6="sm6">
                        <v-text-field
                          label="Alternate Email"
                          v-model="User.alternativeEmail"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12="xs12" sm6="sm6">
                        <v-text-field
                          v-model="User.loginPassword"
                          label="Login Password"
                          type="password"
                        >
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12="xs12" sm6="sm6">
                        <v-text-field
                          label="Phone Number"
                          v-model="User.phoneNumber"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12="xs12" sm12="sm12">
                        <v-text-field
                          label="Address"
                          v-model="User.address"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12="xs12" sm4="sm4">
                        <v-text-field
                          label="City"
                          v-model="User.city"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12="xs12" sm4="sm4">
                        <v-text-field
                          label="State"
                          v-model="User.state"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12="xs12" sm4="sm4">
                        <v-text-field
                          label="Zipcode"
                          v-model="User.zipcode"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </form>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex
              xs12="xs12"
              sm6="sm6"
              v-if="currentUser.accountTypeID <= 2"
            >
              <v-flex>
                <v-card>
                  <v-toolbar class="elevation-0" height="45" color="gray">
                    <v-toolbar-title>
                      <h1 class="subheading">
                        {{ $t("pageHeader.userRights") }}
                      </h1>
                    </v-toolbar-title>
                  </v-toolbar>
                  <v-card-text>
                    <v-layout row="row" wrap="wrap">
                      <v-flex xs12="xs12">
                        <v-select
                          :items="accountType"
                          v-model="User.accountTypeID"
                          item-text="accountTypeName"
                          item-value="accountTypeID"
                          return-object="return-object"
                          :error-messages="accountTypeIDErrors"
                          @input="assignRightsByType"
                          :label="$t('labels.accountType')"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12="xs12">
                        <v-autocomplete
                          :items="rights"
                          item-text="rightName"
                          return-object="return-object"
                          :label="$t('labels.userRights')"
                          @input="addRight"
                        ></v-autocomplete>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex>
                <v-card v-if="givenRightsArray.length">
                  <v-toolbar class="elevation-0" height="45" color="gray">
                    <v-toolbar-title style="width: 100%">
                      <v-layout class="pa-0 ma-0" row="row">
                        <h1 class="subheading">
                          {{ $t("pageHeader.assignedRights") }}
                        </h1>
                        <v-spacer></v-spacer>
                        <h1 class="subheading">
                          {{ givenRightsArray.length }}
                        </h1>
                      </v-layout>
                    </v-toolbar-title>
                  </v-toolbar>
                  <v-card-text class="list-350"
                    ><template v-for="(item, index) in givenRightsArray">
                      <v-layout class="pointer" column="column">
                        <v-flex class="pb-0">
                          <v-layout>
                            <v-flex class="font-weight-light"
                              ><span>
                                <v-btn
                                  icon="icon"
                                  color="red"
                                  @click="removeRight(item)"
                                >
                                  <v-icon color="white">delete</v-icon>
                                </v-btn> </span
                              ><span class="subheading"
                                >{{ item.rightName }}
                              </span></v-flex
                            >
                          </v-layout>
                        </v-flex>
                      </v-layout>
                      <v-divider
                        v-if="index + 1 < givenRightsArray.length"
                        :key="index"
                      ></v-divider> </template
                  ></v-card-text>
                </v-card>
              </v-flex>
            </v-flex>
          </v-layout>
        </v-container>
        <v-card class="border-r-0">
          <v-card-actions>
            <v-btn
              color="blue darken-1"
              outline="outline"
              flat="flat"
              @click="cancel"
              >Cancel</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" dark="dark" @click="update"
              >update</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-layout>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import userService from "../service.js";
const { validationMixin } = require("vuelidate");
const {
  required,
  minLength,
  minValue,
  sameAs,
  email,
} = require("vuelidate/lib/validators");

export default {
  name: "edit-User",
  data() {
    return {
      imageName: "",
      imageUrl: "",
      imageFile: "",
      accountType: [],
      userRightCatalog: [],
      assignedRight: null,
      userRightsArray: [],
      accountName: null,
      isLoading: true,
      User: {
        userName: null,
        fullName: null,
        phoneNumber: null,
        loginEmail: null,
        loginPassword: null,
        address: null,
        city: null,
        state: null,
        zipcode: null,
        alternativeEmail: null,
        isActive: true,
        userRights: null,
        imageUrl: null,
        image: null,
        accountTypeID: null,
      },
      rights: [],
      givenRightsArray: [],
    };
  },
  mixins: [validationMixin],
  validations: {
    User: {
      fullName: {
        required,
        minLength: minLength(2),
      },
      loginEmail: {
        required,
        email,
      },
      accountTypeID: {
        required,
      },
    },
  },
  computed: {
    ...mapGetters("global", ["currentUser"]),
    fullNameErrors() {
      const errors = [];
      if (!this.$v.User.fullName.$dirty) return errors;
      if (!this.$v.User.fullName.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.User.fullName.minLength)
        errors.push(this.$t("validations.fieldMustbeatLeast4ChrLong"));
      return errors;
    },
    loginEmailErrors() {
      const errors = [];
      if (!this.$v.User.loginEmail.$dirty) return errors;
      if (!this.$v.User.loginEmail.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.User.loginEmail.email)
        errors.push(this.$t("validations.emailIsNotValid"));
      return errors;
    },
    accountTypeIDErrors() {
      const errors = [];
      if (!this.$v.User.accountTypeID.$dirty) return errors;
      if (!this.$v.User.accountTypeID.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      return errors;
    },
    assignedRights() {
      var temp = this.rights.filter((rights) => rights.assigned == true);
      return temp.length;
    },
    progress() {
      return (this.assignedRights / this.rights.length) * 100;
    },
    unassignedRights() {
      return this.rights.length - this.assignedRights;
    },
  },
  async created() {
    await this.getAllUserRights();
    await this.getAllAccountType();
    await this.loadUser();
  },
  watch: {
    imageUrl(val) {
      this.User.image = val;
    },
  },
  methods: {
    async loadUser() {
      if (!this.$route.params || !this.$route.params.id)
        return this.$router.push("/user/list");
      const id = this.$route.params.id;
      if (this.currentUser.userID === id) {
        await this.getUserById(id);
      } else {
        if (this.currentUser.accountTypeID <= 2) {
          await this.getUserById(id);
        } else {
          await this.getUserById(this.currentUser.userID);
        }
      }

      this.setPreAssignedRights();
    },
    setPreAssignedRights() {
      let rights = this.User.userRights.split(",");
      rights.map((x) => {
        this.rights.map((y) => {
          if (y.rightID == x) {
            this.givenRightsArray.push(y);
          }
        });
      });
    },
    getUserById(id) {
      return userService.getById(id).then((response) => {
        console.log("response", response);
        this.User = response;
        this.User.loginPassword = null;
        this.accountName = this.User.AccountType.accountTypeName;
        this.imageUrl = this.User.imageUrl;
        this.isLoading = false;
        return;
      });
    },
    pickFile() {
      this.$refs.image.click();
    },
    onFilePicked(e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        this.imageName = files[0].name;
        if (this.imageName.lastIndexOf(".") <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          this.imageUrl = fr.result;
          this.imageFile = files[0]; // this is an image file that can be sent to server...
        });
      } else {
        this.imageName = "";
        this.imageFile = "";
        this.imageUrl = "";
      }
    },
    addRight(obj) {
      let foundit = false;
      this.givenRightsArray.map((row) => {
        if (row.rightID === obj.rightID) {
          foundit = true;
        }
      });
      if (!foundit) {
        this.givenRightsArray.push(obj);
      } else {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            type: "error",
            title: "Right already exists",
          });
      }
    },
    removeRight(item) {
      let index = this.givenRightsArray.findIndex(
        (x) => x.rightID === item.rightID
      );
      this.givenRightsArray.splice(index, 1);
    },
    cancel() {
      this.$router.go(-1);
    },
    assignRightsByType(obj) {
      this.accountName = obj.accountTypeName;
      this.givenRightsArray = [];
      this.rights.map((right) => {
        let accounts = right.accountTypeID.split(",");
        accounts.map((account) => {
          if (account == obj.accountTypeID) this.givenRightsArray.push(right);
        });
      });
      this.User.accountTypeID = obj.accountTypeID;
    },
    getAllUserRights() {
      return userService.getAllUserRights().then((result) => {
        this.rights = result.data;
      });
    },
    getAllAccountType() {
      return userService.getAllAccountType().then((result) => {
        this.accountType = result.data;
      });
    },
    update() {
      let newRights = [];
      this.givenRightsArray.map((x) => {
        newRights.push(x.rightID);
      });
      this.User.userRights = newRights.toString();
      this.User.userName = this.User.fullName;
      console.log("this.User", this.User);
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            type: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
      } else {
        if (this.User.image && this.User.image.substring(0, 4) === "http") {
          delete this.User.image;
        }
        return userService
          .update(this.User.userID, { User: this.User })
          .then((result) => {
            if (result.status) {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                })
                .fire({
                  type: "success",
                  title: "User Updated!",
                });
              this.$store.dispatch("global/initUser");
            }
          })
          .catch((err) => {
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                type: "error",
                title: err.data.data,
              });
          });
      }
    },
  },
};
</script>

<style>
.imgSize {
  width: 120px;
  height: 180px;
}
</style>